export default {
    url: '/roles',
    template: '<ui-view></ui-view>',
    abstract: true
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/permissions/roles/index.js